<div class="avatar-wrapper">
    <div
        class="investment-type-stamp"
        [class.investment-type-stamp--portfolio]="isPortfolio()"
        nz-tooltip
        autoCloseOnScroll
        [nzTooltipVisible]="investmentTypeTooltipVisible()"
        (nzTooltipVisibleChange)="onInvestmentTypeTooltipVisibleChange($event)"
        (click)="onInvestmentTypeTooltipVisibleChange(!investmentTypeTooltipVisible(), $event)"
        nzTooltipOverlayClassName="lean"
        [nzTooltipTitle]="portfolioTypeTooltip"
    >
        {{ isPortfolio() ? 'P' : 'S' }}
    </div>
    <ng-template #portfolioTypeTooltip>
        <liberro-tooltip-content>
            <div tooltipContent class="type-tooltip-content">
                {{ ('investmentTile.typeTooltip.' + (isPortfolio() ? 'portfolio' : 'strategy')) | translate }}
            </div>
        </liberro-tooltip-content>
    </ng-template>
    <liberro-avatar-photo
        [fallbackType]="'portfolio'"
        [photoUrl]="portfolioDetail()?.img ?? (portfolioDetail()?.image?.exists ? portfolioDetail()!.image!.url : null)"
        class="avatar"
        size="44"
    ></liberro-avatar-photo>
</div>